module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.1086/js/_core/img/whatsapp.png"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!/usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/img/whatsapp.png
// module id = 573
// module chunks = 3 4 5